var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuarters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.441 11.2H5V6.455a.66.66 0 0 1 .668-.655h1.577c.37 0 .668.294.668.655V10.3h.193l-.003-1.985V7.046c0-.144.118-.26.265-.26h.654c.264 0 .478.274.478.612V10.3h1.359c.243 0 .441.202.441.45s-.197.45-.44.45H5.44Zm-.109-.886a.433.433 0 0 1 .11-.014h.597a.156.156 0 0 0 .008-.05v-.394a.161.161 0 0 0-.163-.16h-.403a.161.161 0 0 0-.162.16v.395c0 .022.004.044.013.063ZM10.245 13h-4.5c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h4.5c1.24 0 2.25 1.01 2.25 2.25v4.5c0 1.24-1.01 2.25-2.25 2.25ZM5.748 4.818c-.79 0-1.431.643-1.431 1.432v4.5c0 .79.642 1.432 1.431 1.432h4.5c.79 0 1.432-.643 1.432-1.432v-4.5c0-.79-.643-1.432-1.432-1.432h-4.5Zm.299 4.269v-.395a.161.161 0 0 0-.163-.159h-.403a.161.161 0 0 0-.162.16v.394c0 .088.073.16.162.16h.403c.09 0 .163-.072.163-.16Zm0-1.164v-.395a.161.161 0 0 0-.163-.159h-.403a.161.161 0 0 0-.162.16v.394c0 .088.073.16.162.16h.403c.09 0 .163-.072.163-.16Zm0-1.164v-.394a.161.161 0 0 0-.163-.16h-.403a.161.161 0 0 0-.162.16v.394c0 .088.073.16.162.16h.403c.09 0 .163-.072.163-.16Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarters);
export default __webpack_public_path__ + "static/media/quarters.28ac6fe8b8532b65ea84084667f9f0a4.svg";
export { ForwardRef as ReactComponent };